<template>
  <div class="loan-application-loading">
    <Container>
      <Card padding="large" class="text-center">
        <Alert type="error" v-if="hasLoanApplicationError">
          <div>
            <span v-html="errorMessage" />
            <BLink
              @click="$router.push({ name: ROUTES.LOAN_APPLICATION.name })"
              >{{ $t('LOAN_APPLICATION') }}</BLink
            >
          </div>
        </Alert>
        <Margins v-else>
          <h1 class="h3 text-normal">
            {{ $t('PLEASE_WAIT_FOR_CHECK_TO_COMPLETE') }}
          </h1>
          <p class="text-small">{{ $t('IT_TAKES_SOME_TIME') }}</p>
          <Loader class="margins__double" />
        </Margins>
      </Card>
    </Container>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { HAS_LOAN_APPLICATION_ERROR, SUBMIT_LOAN_APPLICATION } from '@/types';
import { Alert, Card, Container, Loader, Margins } from '@/components';
import { constants } from '@/mixins';
import { BLink } from 'bootstrap-vue';

export default {
  name: 'LoanApplicationLoading',
  mixins: [constants],
  components: {
    Container,
    Card,
    Margins,
    Loader,
    Alert,
    BLink,
  },
  mounted() {
    this.SUBMIT_LOAN_APPLICATION();
  },
  beforeDestroy() {
    if (this.hasLoanApplicationError) {
      this.HAS_LOAN_APPLICATION_ERROR(false);
    }
  },
  methods: {
    ...mapActions([SUBMIT_LOAN_APPLICATION]),
    ...mapMutations([HAS_LOAN_APPLICATION_ERROR]),
  },
  computed: {
    ...mapState(['hasLoanApplicationError']),
    errorMessage() {
      const supportEmail = process.env.VUE_APP_SUPPORT_EMAIL;

      return this.$t('FORM.ERROR', [
        '<br />',
        `<a href="mailto:${supportEmail}">${supportEmail}</a>`,
      ]);
    },
  },
};
</script>
